import { Component, OnInit } from '@angular/core';
import { Section } from 'src/app/core/models/DigitalKit';
import { Carousel } from 'src/app/core/models/DigitalKit';
import { infoKitCard } from 'src/app/core/models/DigitalKit';
import { Title } from '@angular/platform-browser';
import $ from 'jquery';
import 'bootstrap';

@Component({
  selector: 'app-business-development',
  templateUrl: './business-development.component.html',
  styleUrls: ['./business-development.component.css'],
  standalone: false
})
export class BusinessDevelopmentComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Desarrollo Comercial');

    (<any>$('.carousel')).carousel();
  }


  sections: Section[] = [
    {
      title: 'Estrategia Comercial',
      description: 'Diseño de planes comerciales adaptados a tu mercado, enfocados en generar nuevas oportunidades y mejorar la posición competitiva.',
      icon: 'assets/svg/puzzle.svg'
    },
    {
      title: 'Optimización del proceso de ventas',
      description: 'Análisis y mejora del funnel comercial, metodologías de venta consultiva y automatización de acciones para aumentar la eficiencia del equipo.',
      icon: 'assets/svg/smartphone.svg'
    },
    {
      title: 'Integración de herramientas comerciales',
      description: 'Implementación y adaptación de CRM, sistemas de seguimiento de leads y automatización comercial para mejorar la gestión del cliente.',
      icon: 'assets/svg/development.svg'
    },
    {
      title: 'Consultoría Comercial',
      description: 'Análisis del mercado, auditoría comercial y definición de estrategias para potenciar la captación y gestión de clientes.',
      icon: 'assets/svg/social-media.svg'
    },
    {
      title: 'Evaluación de rendimiento',
      description: 'Revisión de métricas comerciales, KPIs clave y desempeño de equipos para garantizar resultados consistentes y escalables.',
      icon: 'assets/svg/quality.svg'
    },
    {
      title: 'Acompañamiento y mejora continua',
      description: 'Soporte continuo, entrenamiento comercial y evolución estratégica para mantener un crecimiento sostenible en el tiempo.',
      icon: 'assets/svg/work.svg'
    }
  ]

  carousels: Carousel[] = [
    {
      img: 'assets/img/microsoft.png'
    },
    {
      img: 'assets/img/hubspot.webp'
    },
    {
      img: 'assets/img/salesforce.png'
    },
    {
      img: 'assets/img/zoho.png'
    },
  ]

  values: infoKitCard[] = [
    {
      icon: { src: 'assets/img/clock.png', alt: 'clock' },
      text: 'Time to market'
    },
    {
      icon: { src: 'assets/svg/lock.svg', alt: 'lock' },
      text: 'Seguridad'
    },
    {
      icon: { src: 'assets/svg/piggy-bank.svg', alt: 'piggy bank' },
      text: 'Menos costes, menos riesgos'
    }
  ]


  get firstThreeSections() {
    return this.sections.slice(0, 3);
  }

  get lastThreeSections() {
    return this.sections.slice(3, 6);
  }

}
